module.exports = __webpack_public_path__ + "img/app.436fa48e.png";